<template>
  <div class="errorbody container" :class="theme_type">
    <div v-if="theme_type=='showtime'" class="container">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a class="page_text_font" href="/">{{$t('home.home')}}</a>
        </li>
        <li class="breadcrumb-item page_text_font active">404{{$t('error.not_found_title')}}</li>
      </ol>
    </div>
    <h1 class="title_font2 text-uppercase">404 {{$t('error.not_found_title')}}</h1>
    <v-line v-if="theme_type!='showtime'"></v-line>
    <p class="page_text_font">
      {{$t('error.not_found_content')}}
      <a class="page_text_font" href="/">{{$t('error.click_here')}}</a>
      {{$t('error.to_continue_shopping.')}}
    </p>
  </div>
</template>
<script>
export default {
  props: ["theme_type"],
  data() {
    return {};
  },
  mounted() {
    console.log("theme_type", this.theme_type);
  },
  methods: {}
};
</script>
<style scoped lang='scss'>
.errorbody {
  text-align: center;

  h1 {
    margin-top: 160px;
    font-size: 26px;
  }

  p {
    font-size: 15px;

    a {
      color: #a26b25;
      text-decoration: none;
    }
  }
}
.venue,.athena {
  padding-bottom: 90px !important;
}
.vogue {
  padding-bottom: 90px !important;
  h1{
    margin-bottom: 15px;
  }
}
.showtime {
  h1 {
    margin-top: 30px;
  }
  p {
    margin-bottom: 60px;
  }
}

</style>